import {DomainAncestor, entityConfig} from "core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {LovItem} from "core/metamodel/mdEntity";
import {ID} from "core/metamodel/metaConstant";


@entityConfig()
export class EmployeeAttendance extends DomainAncestor {

  @observable employeeAttendanceId: number;
  @observable employee: LovItem;
  @observable comingTime: string|Date;
  @observable leavingTime: string|Date;


  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.employeeAttendanceId;
  }

  public setId(id: ID): void {
    this.employeeAttendanceId = <any>id;
  }

}



// WEBPACK FOOTER //
// ./src/humanresource/humanResourceDomain.ts